import Button  from 'react-bootstrap/Button'
import {  useNavigate } from 'react-router-dom'

const DummyButton = () => {

  const navigate = useNavigate()
 const Setid = async(id,image) =>{
  await navigate(`/addcampaigns?id=${id}&mediaType=${image}`)
 }

  return (
    <div className='mt-5 me-5'>
        <Button variant='danger'  className='mx-2' onClick={()=>Setid(4761,"image")}>4761</Button>
        <Button variant='danger' className='mx-2' onClick={()=>Setid(4771,"image")}>4771</Button>
        <Button variant='danger' className='mx-2' onClick={()=>Setid(4781,"image")}>4781</Button>
    </div>
  )
}

export default DummyButton